import { emailPattern } from '../constants';

/**
 * Re-export the anchored email regex from constants.
 * If you need a plain regex for react-hook-form `pattern`, use `emailPattern`.
 */
export const emailRegex = emailPattern;

const mailtoPrefixRegex = /^mailto:/i;
const angleBracketRegex = /^[\s<]+|[\s>]+$/g;

export function hasMailtoPrefix(email: string): boolean {
  return mailtoPrefixRegex.test(email.trim());
}

export function stripMailtoPrefix(email: string): string {
  return email.trim().replace(mailtoPrefixRegex, '');
}

export function normalizeEmail(email: string): string {
  return email
    .toLowerCase()
    .trim()
    .replace(angleBracketRegex, '')
    .replace(mailtoPrefixRegex, '');
}

export function isValidEmail(email: string): boolean {
  if (!email || typeof email !== 'string') {
    return false;
  }
  return emailRegex.test(email.trim());
}
